import { useGlobalPeriod } from "../context";
import moment from "moment";
import { PortfolioTradesApi } from "@iliotech/generated-api-v3";
import { useQuery } from "react-query";
import { API_BASE, TABLE_PAGE_SIZE } from "../../constants/constants";
import { ITimePeriod } from "@iliotech/types";

export const useTransactions = (
  portfolioId: string,
  from?: string,
  to?: string,
  overrideKey?: string,
  disablePeriod?: boolean,
  periodOverride?: ITimePeriod
) => {
  const { period } = useGlobalPeriod();
  const finalFrom = disablePeriod
    ? undefined
    : from ||
      (!!period?.from ? moment(period.from).format("YYYY-MM-DD") : undefined);
  const finalTo = disablePeriod
    ? undefined
    : to || (!!period?.to ? moment(period.to).format("YYYY-MM-DD") : undefined);
  const api = new PortfolioTradesApi(undefined, `${API_BASE}/api`);

  return useQuery(
    [
      overrideKey || `portfolio-trades`,
      { portfolioId, from: finalFrom, to: finalTo },
    ],
    () =>
      api.getPortfolioTrades1(
        portfolioId,
        finalFrom,
        finalTo,
        undefined,
        TABLE_PAGE_SIZE
      ),
    {
      refetchOnMount: "always",
    }
  );
};
